<template>
<div>
  <div class="mdl-card__title">
    <h4 class="mdl-card__title-text">{{title}}</h4>
  </div>
  <div class="mdl-card__supporting-text">
      {{{text}}}
  </div>
</div>
</template>
<script>
  var getters = require('common/store/getters')
  var label = require('vue').filter('label')
  module.exports = {
    vuex: {
      getters: getters
    },
    props: {
      service: String
    },
    computed: {
      title: function () {
        return label(this.service.toLowerCase() + '.payment.details.label.title')
      },
      text: function () {
        return label(this.service.toLowerCase() + '.payment.details.text')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PaymentDetails.vue?010fc8fe